<div class="form-component">

    <div class="title-header">
        <h3>Record List</h3>
        <div class="title-buttons">
            <button class="title-button" (click)="onMatchedClicked()">Match</button>
            <button class="title-button" (click)="getMatchedData()">Unmatch</button>
            <button class="title-button" (click)="onCompleteClick()">Complete</button>
        </div>
    </div>

    <form #form="ngForm">
        <div class="top-section">

            <div class="search-legend-container">
                <div class="search-container">
                    <input type="text" class="search-input" placeholder="Search..."
                        [(ngModel)]="search"
                        (keydown.enter)="onSearch()"
                        [ngModelOptions]="{ standalone: true }"/>
                    <div class="dropdown-wrapper">
                        <select class="filter-dropdown"
                            title="Filter target"
                            [(ngModel)]="selectedFilter"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="onFilterDropdownChange()">
                            <option value="">Both</option>
                            <option value="annexure">Annexure</option>
                            <option value="ageing">Ageing</option>
                            <option value="clear">Clear</option>
                        </select>
                    </div>
                    <button type="button" class="search-button" title="Search" aria-label="Search" (click)="onSearch()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
                
                <div class="legend-container">
                    <div class="legend" style="font-size: 14px; margin-top: 5px;">
                        Legend: <i class="fa fa-link"></i> Auto-matched | <i class="fa fa-user-check"></i> Manually matched
                    </div>
                </div>
            </div>

            <div class="filter-section">
                <h4 class="filter-headline">FILTERS</h4>

                <div class="checkbox-group">
                    <label class="checkbox-label">
                        <input type="checkbox" [(ngModel)]="franchiseLoss" [ngModelOptions]="{standalone: true}" (change)="refreshGrids()"> Show Below Non-Qualifying Loss
                    </label>
                    <label class="checkbox-label">
                        <input type="checkbox" [(ngModel)]="matched" [ngModelOptions]="{standalone: true}" (change)="refreshGrids()"> Show Matched Records
                    </label>
                    <label class="checkbox-label">
                        <input type="checkbox" [(ngModel)]="autoMatched" [ngModelOptions]="{standalone: true}" (change)="refreshGrids()"> Show Auto-Matched
                    </label>
                    <label class="checkbox-label">
                        <input type="checkbox" [(ngModel)]="uncategorized" [ngModelOptions]="{standalone: true}" (change)="refreshGrids()"> Show Non Categorized records only
                    </label>
                </div>
            </div>

            <div class="data-display">
                <h4 class="client-headline">CLIENT</h4>

                <div class="client-info-group">
                    <div class="data-item">
                        <span class="data-label">Client Name:</span>
                        <span class="data-display-value">{{ clientName }}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-label">Client Policy:</span>
                        <span class="data-display-value">{{ clientAreaName }}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-label">Period:</span>
                        <span class="data-display-value">{{ period }}</span>
                    </div>
                </div>
            </div>

            <div class="spacer-section">
            </div>
        </div>

        <div class="data-preview-tables-wrapper">
            <div class="tables-container">

                <div class="table-section">
                    <h4>Annexure Listings</h4>
                    <div class="active-filter">Filter: <span>{{ annexureSearch || 'none' }}</span></div>
                    <pageable-table
                        [items]="annexureRows"
                        [paging]="annexurePaging"
                        [columns]="getAnnexureColumnMap()"
                        [showRowGlyph]="true"
                        [glyphColumn]="getAnnexureGlyphColumn()"
                        [showEdit]="true"
                        (editItem)="getAnnexureDataById($event)"
                        [showDelete]="false"
                        [selectionEnabled]="true"
                        [highlightedIds]="highlightedAnnexureIds"
                        (selectionChanged)="onAnnexureRowSelect($event)"
                        (refreshData)="getAnnexureData($event)">
                    </pageable-table>
                </div>

                <div class="table-section">
                    <h4>Ageing Listings</h4>
                    <div class="active-filter">Filter: <span>{{ ageingSearch || 'none' }}</span></div>
                    <pageable-table
                        [items]="ageingRows"
                        [paging]="ageingPaging"
                        [columns]="getAgeingColumnMap()"
                        [showRowGlyph]="true"
                        [glyphColumn]="getAgeingGlyphColumn()"
                        [glyphTooltipColumn]="'rowGlyphTooltip'"
                        [showEdit]="true"
                        (editItem)="getAgeingDataById($event)"
                        [showDelete]="false"
                        [selectionEnabled]="true"
                        [allowMultiSelect]="true"
                        [highlightedIds]="highlightedAgeingIds"
                        (selectionChanged)="onAgeingRowSelect($event)"
                        (refreshData)="getAgeingData($event)">
                    </pageable-table>
                </div>
            </div>
        </div>
    </form>
</div>

<!-- Update Annexure Record Modal -->
<app-modal *ngIf="isUpdateAnnexure" [header]="annexureModalHeader" (onSave)="updateAnnexureRecord()" (onCancel)="onModalCancel()">
    <div class="form-component">
        <form #form="ngForm">
            <div class="input-group">
                <label for="matched">
                    Matched:
                    <i *ngIf="annexureRecord['rowGlyph']" class="{{ annexureRecord['rowGlyph'] }}" style="color: #006f8a;"></i>
                    <i *ngIf="!annexureRecord['rowGlyph']" class="fa fa-times" style="color: red;" title="Not Matched"></i>
                </label>
            </div>

            <div class="input-group">
                <label for="debtorName"> Debtor Name: </label>
                <div>
                    <input
                        name="debtorName"
                        #clientName="ngModel"
                        type="text"
                        [(ngModel)]="annexureRecord.debtorName"
                        disabled>
                </div>
            </div>

            <div class="input-group">
                <label for="debtorCode"> Annexure Number: </label>
                <div>
                    <input
                        name="debtorCode"
                        #clientName="ngModel"
                        type="text"
                        [(ngModel)]="annexureRecord.debtorCode"
                        disabled>
                </div>
            </div>

            <div class="input-group">
                <label for="policyReference"> Policy Reference: </label>
                <div>
                    <input
                        name="policyReference"
                        #clientName="ngModel"
                        type="text"
                        [(ngModel)]="annexureRecord.policyReference"
                        disabled>
                </div>
            </div>

            <div class="input-group">
                <label for="debtorRegistrationNumber"> Registration Number: </label>
                <div>
                    <input
                        name="debtorRegistrationNumber"
                        #clientName="ngModel"
                        type="text"
                        [(ngModel)]="annexureRecord.debtorRegistrationNumber"
                        disabled>
                </div>
            </div>

            <div class="input-group">
                <label for="approvedLimit"> Granted Limit: </label>
                <div>
                    <input
                        name="approvedLimit"
                        #clientName="ngModel"
                        type="number"
                        min="0"
                        [(ngModel)]="annexureRecord.approvedLimit">
                </div>
            </div>
        </form>
    </div>
</app-modal>

<!-- Update Ageing Record Modal -->
<app-modal *ngIf="isUpdateAgeing" [header]="ageingModalHeader" (onSave)="updateAgeingRecord()" (onCancel)="onModalCancel()">
    <div class="form-component">
        <form #form="ngForm">
            <div class="input-group">
                <label for="matched">
                    Matched:
                    <i *ngIf="ageingRecord['rowGlyph']" class="{{ ageingRecord['rowGlyph'] }}" style="color: #006f8a;"></i>
                    <i *ngIf="!ageingRecord['rowGlyph']" class="fa fa-times" style="color: red;" title="Not Matched"></i>
                </label>
            </div>

            <div class="input-group">
                <label for="customerName"> Customer Name: </label>
                <div>
                    <input
                        name="customerName"
                        #clientName="ngModel"
                        type="text"
                        [(ngModel)]="ageingRecord.customerName"
                        disabled>
                </div>
            </div>

            <div class="input-group">
                <label for="customerCode"> Annexure Number: </label>
                <div>
                    <input
                        name="customerCode"
                        #clientName="ngModel"
                        type="text"
                        [(ngModel)]="ageingRecord.customerCode"
                        disabled>
                </div>
            </div>

            <div class="input-group">
                <label for="customerRegistrationNumber"> Registration Number: </label>
                <div>
                    <input
                        name="customerRegistrationNumber"
                        #clientName="ngModel"
                        type="text"
                        [(ngModel)]="ageingRecord.customerRegistrationNumber"
                        disabled>
                </div>
            </div>

            <div class="input-group">
                <label for="comment"> Note: </label>
                <div>
                    <auto-complete-dropdown
                        [options]="noteOptions"
                        [displayWith]="getNoteDisplayText"
                        [initialValue]="selectedNoteId"
                        (selectionChange)="onNoteSelectionChange($event)"
                        placeholder="Select a note...">
                    </auto-complete-dropdown>
                </div>
            </div>

            <div class="input-group" *ngIf="showOtherInput">
                <label for="otherNote"> Other: </label>
                <div>
                    <input
                        name="otherNote"
                        type="text"
                        [(ngModel)]="ageingRecord['comment']"
                        placeholder="Please specify...">
                </div>
            </div>
        </form>
    </div>
</app-modal>
